<re-captcha
  #reCaptcha
  (resolved)="setAlternateReCaptcha($event)"
  (error)="setAlternateReCaptchaError($event)"
  errorMode="handled"
></re-captcha>

@if (hasAlternateReCaptchaError.invalid || hasAlternateReCaptchaError.expired) {
  <div class="form-error">
    <div class="form-error__message">
      @if (hasAlternateReCaptchaError.invalid && !hasAlternateReCaptchaError.expired) {
        {{ 'general.message.error.re-captcha.invalid' | translate }}
      }
      @if (hasAlternateReCaptchaError.expired) {
        {{ 'general.message.error.re-captcha.expired' | translate }}
      }
    </div>
  </div>
}
